import React from "react";
import PageHero from "../components/PageHero";

const sections = [
  { title: "Movies", body: "Gurgaon is flooded with movie halls, most located in malls on MG Road, Sohna Road and NH8. Refer to the Gurgaon Times Movie Guide and plan your day out at the movies." },
  { title: "Shopping", body: "Dubbed the Mall Capital of India, Gurgaon is a shopper's paradise. Famous destinations include Ambience Mall, Metropolitan Mall, DT Mall, City Centre, Sahara Mall, Central Mall, Qutab Plaza and Galleria. For traditional bazaar shopping at reasonable prices, try Sadar Bazar." },
  { title: "Food", body: "Indian, South Indian, Punjabi, Parsi, Bengali, Chinese, Thai, Continental, Korean, Japanese and everything else you could ask for. The malls have great food courts, while Sector 29 and Cyber Hub are speciality dining areas." },
  { title: "Theatre & Drama", body: "Zangoora at The Kingdom of Dreams in Sector 29 is a must-watch for any theatre buff. Epicentre, near Huda City Centre Metro Station, hosts several plays throughout the year." },
  { title: "Raahgiri", body: "Unique to Gurgaon and held in Sector 27, Sundays 8am-11am. No vehicles ply and the streets belong to the people — music, dance, sports, fitness and entertainment. It's free for all." },
  { title: "Places of Worship", body: "Sai Ka Aangan is an exact replica of the Sai Baba Temple in Shirdi — a peaceful place in Sector 29 with a Palki procession and Aarti on Thursday nights. Alternatively, visit the popular Sheetla Mata Mandir in Sector 5." },
  { title: "Parks", body: "Watch the musical fountains at Leisure Valley Park, walk at Tau Devi Lal or Aravalli Bio Diversity Parks, and watch migratory birds at Sultanpur Bird Sanctuary in winter. Water parks like Oysters Beach and Aapno Ghar and adventure parks are close by too." },
  { title: "Day Trips", body: "Weekend trips to Sariska forest (spot tigers & leopards), the World Heritage sites of Agra & Fatehpur Sikri, the historic city of Jaipur, and of course Delhi — only 30 minutes away — for history, shopping and food." },
];

export default function MillenniumCityPage() {
  return (
    <div data-testid="millennium-city-page">
      <PageHero
        path="millennium-city.hero"
        kicker="Student Life"
        title="Life in Millennium City"
        subtitle="Located in Gurgaon, India's Millennium City, Kiki offers students plenty to do on their days off."
      />
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-6">
          {sections.map((s) => (
            <div key={s.title} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
              <h3 className="text-lg font-bold text-[#0B2A6B] mb-2">{s.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
